// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-aiD","question":"styles_question__3CBvP","inputVisibleButton":"styles_inputVisibleButton__ytmDW","note":"styles_note__2lwNb"};